export const DEFAULT_CODE = {
  html: `<h1>Hello World</h1>`,
  css: `h1 { color: red; }`,
  javascript: `console.log('Hello JS');`,
  json: `{
  "name": "chatgpt",
  "version": 1
}`,
  xml: `<?xml version="1.0" encoding="UTF-8"?>
<root>
  <element>XML 내용</element>
</root>`
};